import { useContext } from "react";
import { GlobalStateContext } from "../store/GlobalState";
export default () => {
  const context = useContext(GlobalStateContext);
  return context;
};
